import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Loading from '@hapana/shared/web/components/shared/loading/loading.component'
import Button from '@hapana/shared/web/components/shared/button/button.component'
import { BUTTON_VARIANTS } from '@hapana/shared/web/components/shared/button/button.constants'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'
import useSiteStore from '_stores/site.store'
import { useListAvailableEquipments } from '_hooks/equipments.hooks'

import { EquipmentImage } from '_components/check-in-widget/equipment-image/equipment-image.component'
import { styles } from './equipments-available.styles'
import { AssignToEquipmentDialog } from './assign-to-equipment-dialog/assign-to-equipment-dialog.component'

export const EquipmentsAvailable = ({ clientId, clientName }) => {
  const { t } = useTranslation('checkIn')
  const siteId = useSiteStore((state) => state.currentSite?.siteId)
  const { pushDialog } = useDialog()
  const { data: availableEquipments, isLoading: isLoadingAvailableEquipments } =
    useListAvailableEquipments(siteId)

  const availableEquipmentsCount = availableEquipments?.availableEquipments?.length || 0

  return isLoadingAvailableEquipments ? (
    <Box sx={styles.loadingContainer}>
      <Loading />
    </Box>
  ) : (
    <Box sx={styles.tanningFeaturesContainer}>
      <Box sx={styles.imagesTextContainer}>
        <Box sx={styles.availableEquipmentsContainer}>
          {availableEquipments?.availableEquipments?.slice(0, 2).map((item) => (
            <Box sx={styles.tanningFeatureImageContainer} key={item.equipmentId}>
              <EquipmentImage
                sx={styles.tanningFeatureImage}
                src={item.image?.medium || item.image?.thumbnail || item.image?.db}
                name={item.name}
              />
            </Box>
          ))}
        </Box>
        <Box sx={styles.textContainer}>
          <Typography typography="header4" color="gray.80">
            {t('checkIn:availableEquipment', {
              count: availableEquipmentsCount,
            })}
          </Typography>
        </Box>
      </Box>

      <Button
        variant={BUTTON_VARIANTS.CONTAINED}
        label={t('checkIn:equipments.assignToEquipment.title')}
        onClick={() => pushDialog(AssignToEquipmentDialog, { clientId, clientName })}
      />
    </Box>
  )
}

EquipmentsAvailable.propTypes = {
  clientId: PropTypes.string,
  clientName: PropTypes.string,
}
